/**
 * Configuration management (Phase C).
 *
 * - `getConfig` wraps OCPP 1.6 `GetConfiguration` and 2.0.1 `GetVariables`
 *   based on the charger's recorded `ocpp_version`. Pass `keys: []` (or
 *   omit) to fetch the full key set.
 * - `setConfig` requires a non-empty `variables[]` (server returns 400
 *   otherwise).
 */

import { enc, ocppRequest } from './ocppApi';
import type {
  GetConfigHistoryResponse,
  GetConfigResponse,
  GetConfigTemplatesResponse,
  GetDriftResponse,
  SetConfigResponse,
  SetConfigVariable,
} from '../models';

export const getConfig = (chargerId: string, keys?: string[]) =>
  ocppRequest<GetConfigResponse>({
    method: 'POST',
    path: `config/get/${enc(chargerId)}`,
    body: keys && keys.length ? { keys } : {},
  });

export const setConfig = (chargerId: string, variables: SetConfigVariable[]) =>
  ocppRequest<SetConfigResponse>({
    method: 'POST',
    path: `config/set/${enc(chargerId)}`,
    body: { variables },
  });

export const getDriftReport = (chargerId: string) =>
  ocppRequest<GetDriftResponse>({
    method: 'GET',
    path: `config/drift/${enc(chargerId)}`,
  });

export const getConfigHistory = (
  chargerId: string,
  opts: { limit?: number; offset?: number } = {}
) =>
  ocppRequest<GetConfigHistoryResponse>({
    method: 'GET',
    path: `config/history/${enc(chargerId)}`,
    query: { limit: opts.limit, offset: opts.offset },
  });

export const listConfigTemplates = () =>
  ocppRequest<GetConfigTemplatesResponse>({
    method: 'GET',
    path: 'config/templates',
  });
